/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import AbstractFieldGroup from './AbstractFieldGroup';
import { layoutRegistry } from '../../banner/Banner';

export default class Setup extends AbstractFieldGroup {
	fields() {
		return [
			{
				name: 'layout',
				type: 'select',
				options: layoutRegistry.getLayoutKeys(),
			},
			{
				name: 'position',
				type: 'select',
				options: [
					'slider',
					'first_block',
					'second_block',
					'third_block',
					'fourth_block',
					'fifth_block',
					'sixth_block',
					'reading_round',
					'sponsor_above_reviews',
					'sponsor_below_reviews',
					'sponsor_between_community_events',
				],
			},
			{
				name: 'priority',
				type: 'number',
			},
			{
				name: 'start_date',
				type: 'date',
			},
			{
				name: 'end_date',
				type: 'date',
			},
		];
	}
}
